import { formTypes } from "../../../constants";
import { getAllData } from "../../../utils/helpers/fetching";
import { getQueryAndFilter, extractVariables, getUpdatedItems } from "./fetch-common-helpers";

export const fetchCommon =
  ({ queryAsc, queryDesc, queryWithInstrumentAsc, queryWithInstrumentDesc, queryName }) =>
    async ({
      client,
      sortDirection,
      equipmentModel,
      signee,
      instrument,
      dateFrom,
      dateTo,
      storeUser,
      limit,
      nextToken,
      drillData = false,
      inventoryId,
      logType = formTypes.RUN_LOG,
      signeeList
    }) => {
      const { query, filter } = getQueryAndFilter({
        equipmentModel,
        signee,
        sortDirection,
        queryDesc,
        queryAsc,
        instrument,
        dateFrom,
        dateTo,
        queryWithInstrumentDesc,
        queryWithInstrumentAsc,
        inventoryId,
        logType,
        signeeList
      });
      const { nextToken: token, items } = await getAllData({
        client,
        query,
        dataPath: ["data", queryName],
        variables: extractVariables({
          instrument,
          dateFrom,
          dateTo,
          storeUser,
          limit,
          nextToken,
          filter,
          inventoryId
        }),
        drillData
      });

      const updatedItems = getUpdatedItems(items);

      return {
        items: updatedItems,
        token
      };
    };
